export const FETCH_LOG_IN_SUCCESS = 'FETCH_LOG_IN_SUCCESS'
export const FETCH_LOG_IN_ERROR = 'FETCH_LOG_IN_ERROR'
export const FETCH_SIGN_IN_SUCCESS = 'FETCH_SIGN_IN_SUCCESS'
export const REMOVE_SIGN_IN_ERROR = 'REMOVE_SIGN_IN_ERROR'
export const REMOVE_LOG_IN_ERROR = 'REMOVE_LOG_IN_ERROR'
export const FETCH_SIGN_IN_ERROR = 'FETCH_SIGN_IN_ERROR'
export const SET_SIGN_IN_ERROR = 'SET_SIGN_IN_ERROR'
export const SET_SIGN_IN_SUCCESS = 'SET_SIGN_IN_SUCCESS'
export const REMOVE_SIGN_IN_SUCCESS = 'REMOVE_SIGN_IN_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES'
export const FETCH_UPDATE_SUCCESS = 'FETCH_UPDATE_SUCCESS';
